<template>
  <div class="parent">
    <v-card class="top-row py-2 px-3" elevation="2">
      <v-text-field
        class="search-field"
        label="Sök efter bilder"
        prepend-inner-icon="mdi-magnify"
        clearable
        outlined
        dense
        hide-details="true"
        @input="onSearch"
      ></v-text-field>
      <v-btn size="large" color="primary" :to="{ name: 'createImage' }"> Lägg till bild </v-btn>
    </v-card>

    <div class="list mt-3">
      <LatestImages :loading="loading" :items="images">
        <template #pagination>
          <div class="pagination-container">
            <Pagination v-bind="meta" @change="onPagination" />
          </div>
        </template>
      </LatestImages>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import LatestImages from '@/components/images/LatestImages'
import Pagination from '@/components/shared/Pagination.vue'

let debounce = null

export default {
  name: 'ImageList',
  components: { LatestImages, Pagination },
  props: {
    images: { type: Array, default: () => [] },
    loading: { type: Boolean },
    meta: { type: Object },
  },

  computed: {},
  methods: {
    onSearch(val) {
      clearTimeout(debounce)
      debounce = setTimeout(() => {
        this.$emit('image:search', val)
      }, 600)
    },
    onClickNews({ id }) {
      this.$router.push({ name: 'SingleNews', params: { id } })
    },
    onPagination(val) {
      this.$emit('image:pagination', val)
    },
  },
}
</script>

<style lang="less" scoped>
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  .search-field {
    max-width: 400px;
  }
}
.list {
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  grid-template-rows: 1fr;
  grid-column-gap: 15px;
  grid-row-gap: 0px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
}
</style>
